// 不需要鉴权的业务路由
const menuRoutes = [
  {
    path: "/home",
    meta: {
      subtitle: "赣韵地图",
      title: "首页",
    },
    component: () => import("@/views/home/index.vue"),
  },
  {
    path: "/beauty",
    meta: {
      title: "大美江西",
    },
    component: () => import("@/views/beauty/index.vue"),
  },
  {
    path: "/goods",
    meta: {
      title: "百县百品",
      subtitle: "百县百品 千城万店",
    },
    component: () => import("@/views/goods/index.vue"),
  },
  {
    path: "/investment",
    meta: {
      title: "招商赣线",
    },
    component: () => import("@/views/investment/index.vue"),
  },
  {
    path: "/tour",
    meta: {
      title: "旅游美食",
    },
    component: () => import("@/views/tour/index.vue"),
  },
];
export default menuRoutes;
